class IChoseGuthrieHeader extends DrupalBehavior {
    onReady(document) {
      var $navToggle = $('header.ichose-guthrie .hamburger-toggle');
      var $desktopMenu = $('header.ichose-guthrie .hamburger-menu');
      var $mobileMenu = $('header.ichose-guthrie .inner-wrap .content-right');
      var $headerHeight = $('.site-wrap header.ichose-guthrie').outerHeight();
      enquire.register(this.settings.breakpoints['guthrie_theme_guthrie_theme.md_min'].query, {
        match: () => {
          $desktopMenu.css('top', $headerHeight);
          $mobileMenu.show();
          $desktopMenu.hide();
          $navToggle.removeClass('open').unbind('click');
          $navToggle.on('click', function(event) {
            event.preventDefault();
            $(this).toggleClass('open');
            $desktopMenu.fadeToggle('fast');
          });
        },
      });
      enquire.register(this.settings.breakpoints['guthrie_theme_guthrie_theme.sm_max'].query, {
        match: () => {
          $mobileMenu.css('top', $headerHeight);
          $mobileMenu.hide();
          $desktopMenu.hide();
          $navToggle.removeClass('open').unbind('click');;
          $navToggle.on('click', function(event) {
            event.preventDefault();
            $(this).toggleClass('open');
            $mobileMenu.fadeToggle('fast');
          });
        },
      });
    }
    onContent() {   
        $(window).on('resize', function () {
            var position = $('.site-wrap header.ichose-guthrie .inner-wrap').offset();
            $('header.ichose-guthrie .hamburger-menu').css('right', position.left);
        }).resize();
    }
  }
  DrupalBehavior.register('guthrie_theme.components', 'i-chose-guthrie-header', IChoseGuthrieHeader);